<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ application_obj?.application_type }} -->
    <AppFormView_11000
      :get_targetid="$route.params.id"
      v-if="application_obj?.application_type == 11000"
    ></AppFormView_11000>
    <AppFormView_11300
      :get_targetid="$route.params.id"
      v-if="application_obj?.application_type == 11300"
    ></AppFormView_11300>
    <AppFormView_11400
      :get_targetid="$route.params.id"
      v-if="application_obj?.application_type == 11400"
    ></AppFormView_11400>
    <AppFormView_12000
      :get_targetid="$route.params.id"
      v-if="
        [
          12100, 12110, 12200, 12300, 12400, 12500, 12340, 12600, 13110
        ].includes(parseInt(application_obj?.application_type))
      "
    ></AppFormView_12000>
  </div>
</template>
<style scoped>
.fs-6 {
  font-size: 1.15rem !important;
}
.fs-7 {
  font-size: 1rem !important;
}
.fs-8 {
  font-size: 0.9rem !important;
}
</style>
<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
import config from '../../../const'
import common from '../../../common/common'
import * as bootstrap from 'bootstrap'

import AppFormView_11000 from './AppFormView_11000.vue'
import AppFormView_11300 from './AppFormView_11300.vue'
import AppFormView_11400 from './AppFormView_11400.vue'
import AppFormView_12000 from './AppFormView_12000.vue'

export default {
  name: 'OwnerApplicationDataView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: '主催者申請詳細',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      application_obj: {},
      application_check_type_obj: [],
      application_type_obj: [],
      application_key_obj: [],
      event_cd_obj: [],
      search_license_no: '',
      search_member_name_label: '',
      item_column: {
        id: 0,
        application_id: 0,
        application_key: '',
        application_value: '',
        permission_date: '',
        permission_sw: false,
        permission_manage_id: '',
        permission_manage_label: '',
        message: ''
      },
      oParam: ['item'],
      rejectModal: null,
      set_owner_no: '',
      set_application_check_type: ''
    }
  },
  components: {
    BsPageTitle,
    // BsSelect,
    BsMsgAlert,
    AppFormView_11000,
    AppFormView_11300,
    AppFormView_12000,
    AppFormView_11400
  },
  methods: {
    async add_item() {
      const tmps = { ...this.item_column }
      tmps.manage_id = this.$store.state.auth.userId
      tmps.manage_label = this.$store.state.auth.label
      const items =
        typeof this.application_obj.items === 'object'
          ? this.application_obj.items
          : []
      items.push(tmps)
      this.application_obj.items = items
    },
    async set_application_permission() {
      this.application_obj.permission_manage_id = this.$store.state.auth.userId
      this.application_obj.permission_date_date = common.getToday()
      this.application_obj.permission_manage_label =
        this.$store.state.auth.label
    },
    async clear_application_permission() {
      this.application_obj.permission_manage_id = 0
      this.application_obj.permission_date_date = ''
      this.application_obj.permission_manage_label = ''
    },
    async set_item_permission(index) {
      this.application_obj.items[index].permission_manage_id =
        this.$store.state.auth.userId
      this.application_obj.items[index].permission_date_date = common.getToday()
      this.application_obj.items[index].permission_manage_label =
        this.$store.state.auth.label
    },
    async clear_item_permission(index) {
      this.application_obj.items[index].permission_manage_id = 0
      this.application_obj.items[index].permission_date_date = ''
      this.application_obj.items[index].permission_manage_label = ''
    },

    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/config/' + param, params)
        .then(async response => {
          console.log('loadConfigObj response', response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async search_member_license_no() {
      if (this.search_license_no.length == 6) {
        await this.loadMemberList(this.search_license_no)
      }
    },
    async loadMemberList(license_no) {
      const params = {}
      params['stat'] = [1]
      params['license_no'] = license_no
      params['pagegroup'] = 'mfj_owner_data.id'

      await this.basicPosts_S(config.BASE_API_URL + '/owner/lists', params)
        .then(async response => {
          console.log('loadMemberList response', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
          let name_label = ''
          if (typeof tmp_obj.name_1 === 'string') name_label += tmp_obj.name_1
          if (typeof tmp_obj.name_2 === 'string') name_label += tmp_obj.name_2
          if (typeof tmp_obj.name_3 === 'string') name_label += tmp_obj.name_3
          this.search_member_name_label = name_label
          this.application_obj.m_id = tmp_obj.id
        })
        .catch(async err => {
          console.log(err)
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadMemberObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/owner_application/lists',
        params
      )
        .then(async response => {
          console.log('loadMemberObj', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}

          if (!tmp_obj.items) {
            tmp_obj.items = []
          }
          const items = tmp_obj.items.map(item => {
            if (this.is_json(item.application_value)) {
              item.application_value = JSON.parse(item.application_value)
            }
            return item
          })
          tmp_obj.items = items

          this.application_obj = tmp_obj
          console.log('Loaded application_obj:', this.application_obj)
        })
        .catch(async err => {
          console.log(err)
          this.application_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEventCdObj() {
      try {
        const response = await this.basicPosts_S(
          `${config.BASE_API_URL}/event_cd/lists`,
          { stat: [1] }
        )
        if (response.data?.status === 200) {
          this.event_cd_obj = response.data.body || []
          console.log('Loaded events:', this.event_cd_obj)
        }
      } catch (error) {
        console.error('Error loading events:', error)
        this.event_cd_obj = []
      }
    },
    async update_application() {
      const params = this.application_obj
      if (this.pass_chg_sw && this.pass_chg_confirm != this.login_pass_input) {
        alert('パスワードが一致しません')
        return true
      } else if (this.pass_chg_sw && this.pass_chg_confirm == '') {
        alert('パスワードを入力して下さい')
        return true
      } else if (
        this.pass_chg_sw &&
        this.pass_chg_confirm == this.login_pass_input
      ) {
        params.login_pass = this.login_pass_input
      }

      await this.update(params)
    },
    async update(params) {
      console.log('component methods', this.application_obj)
      const post_url = this.not_add
        ? config.BASE_API_URL + '/owner_application/edit/' + this.targetid
        : config.BASE_API_URL + '/owner_application/add'

      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update member response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = this.btnLabel + 'しました'
            this.alertClass = 'alert-success'
            this.targetid = response.data.body[0].id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
            if (typeof response.data.alert.error_obj === 'object') {
              const tmp_error = { ...this.member_error_obj }
              Object.keys(response.data.alert.error_obj).forEach(key => {
                tmp_error[key] = response.data.alert.error_obj[key]
              })
              this.member_error_obj = tmp_error
            }
          } else {
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) await this.loadMemberObj()
          this.$forceUpdate()
          alert(this.alertMessage)
        })
    },
    back() {
      this.$router.go(-1)
    },
    tab_switch_action(tab) {
      this.tab_active = tab
    },
    go_consulting() {
      this.$router.push({
        // name: 'process_detail',
        path: '/consulting/add',
        query: {
          m_id: this.targetid,
          clinic_id: this.application_obj.main_clinic_id
        }
      })
    },
    formatLabel(key) {
      const labelMap = {
        'mfj_owner_data@login_id': 'ログインID',
        'mfj_owner_data@login_pass': 'パスワード',
        'mfj_owner_data@name_1': '主催者名',
        'mfj_owner_data@name_2': '責任者姓',
        'mfj_owner_data@name_3': '責任者名',
        'mfj_owner_data@yomi_1': '主催者名カナ',
        'mfj_owner_data@yomi_2': '責任者セイ',
        'mfj_owner_data@yomi_3': '責任者メイ',
        'mfj_owner_profile@postal_cd': '郵便番号',
        'mfj_owner_profile@pref_cd': '都道府県',
        'mfj_owner_profile@address_1': '住所1',
        'mfj_owner_profile@address_2': '住所2',
        'mfj_owner_profile@tel_1': '電話番号1',
        'mfj_owner_profile@tel_2': '電話番号2',
        'mfj_owner_profile@mail_1': 'メールアドレス',
        'mfj_owner_profile@website_url_1': 'Webサイト',
        'mfj_owner_data@event_relation': '活動種目'
      }
      // const parts = key.split('@')
      // return labelMap[parts[1]] || parts[1] || key
      return labelMap[key]
    },
    formatValue(value) {
      if (!value) return ''

      try {
        const parsed = JSON.parse(value)
        if (Array.isArray(parsed)) {
          return parsed.join(', ')
        }
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return value
      }
    },
    isJsonValue(value) {
      try {
        JSON.parse(value)
        return true
      } catch (e) {
        return false
      }
    },
    async setPermission() {
      if (confirm('この申請を承認しますか？')) {
        this.set_application_check_type = '500'
        await this.updateApplication()
      }
    },
    getToday() {
      const today = new Date()
      const yyyy = today.getFullYear()
      const mm = String(today.getMonth() + 1).padStart(2, '0')
      const dd = String(today.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    async updateApplication() {
      if (!this.set_owner_no && this.set_application_check_type == 500) {
        alert('owner noを入力して下さい。')
        this.set_application_check_type = ''
        return
      } else if (this.set_application_check_type == 500) {
        const chk = await this.basicPosts_S(
          config.BASE_API_URL + '/owner/lists',
          {
            owner_no: this.set_owner_no
          }
        ).then(async response => {
          return response?.data &&
            response?.data?.body &&
            Array.isArray(response.data.body) &&
            response.data.body.length > 0
            ? true
            : false
        })
        if (chk) {
          alert('そのowner noは使えません')
          this.set_application_check_type = ''
          return
        }
      }
      const params = { ...this.application_obj }
      // owner_no
      params.set_owner_no = this.set_owner_no
      params.application_check_type = this.set_application_check_type
      params.permission_date_date = this.getToday()
      params.permission_manage_id = this.$store.state.auth.userId
      params.permission_manage_label = this.$store.state.auth.label

      // app_type:join(申請承認登録時JOINをセットしておく。)
      // owner_idが
      if (this.set_application_check_type == 500) params.app_type = 'join'
      const url =
        this.set_application_check_type == 500
          ? config.BASE_API_URL +
            '/owner_application/join_edit/' +
            this.targetid
          : config.BASE_API_URL + '/owner_application/edit/' + this.targetid
      this.set_application_check_type = ''
      try {
        const response = await this.basicPosts_I(url, params)
        console.log('updateApplication response', response)
        if (response.data && response.data.status == '200') {
          this.alertMessage = '更新が完了しました'
          this.alertClass = 'alert-success'
          await this.loadMemberObj()
        } else {
          this.alertMessage = '更新に失敗しました'
          this.alertClass = 'alert-danger'
        }
      } catch (error) {
        console.error('Error:', error)
        this.alertMessage = '更新に失敗しました'
        this.alertClass = 'alert-danger'
      }
      alert(this.alertMessage)
    },
    // async setItemPermission(index) {
    //   if (confirm('この項目を承認しますか？')) {
    //     const today = this.getToday()
    //     this.application_obj.items[index].permission_date = today
    //     this.application_obj.items[index].permission_date_date = today
    //     this.application_obj.items[index].permission_manage_id =
    //       this.$store.state.auth.userId
    //     this.application_obj.items[index].permission_manage_label =
    //       this.$store.state.auth.label
    //     await this.updateApplication()
    //   }
    // },
    showRejectModal() {
      this.rejectModal.show()
    },
    async rejectApplication() {
      if (!this.application_obj.comment) {
        alert('差し戻しコメントを入力してください')
        return
      }

      this.application_obj.application_check_type = '600'
      await this.updateApplication()
      this.rejectModal.hide()
    }
  },
  computed: {
    ...mapState({
      // sex_type_list: state => state.apidata.sex_type,
    }),
    get_list_label: function () {
      return function (key, lists) {
        if (
          key &&
          typeof lists === 'object' &&
          lists.find(list => list.key == key)
        ) {
          return (lists.find(list => list.key == key) || {}).label
        }
        return key
      }
    },
    application_type_list: function () {
      return this.application_type_obj
    },
    application_check_type_list: function () {
      return this.application_check_type_obj
    },

    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    }
  },

  async created() {
    await this.loadEventCdObj()
    await this.loadConfigObj('application_check_type')
    await this.loadConfigObj('application_type')
    await this.loadConfigObj('application_key')
    // await this.loadConfigObj('application_key.210');

    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      await this.loadMemberObj()
      this.btnLabel = '更新'
    } else {
      this.application_obj = Object.assign({
        id: 0,
        stat: 1,
        m_id: 0,
        application_check_type: '',
        application_type: '',
        application_date: '',
        permission_date_date: '',
        permission_date: '',
        permission_manage_id: '',
        permission_manage_label: '',
        permission_sw: false,
        items: []
      })
      this.btnLabel = '登録'

      // set
      // this.application_obj.profile.push({...this.profile_column});
      // this.application_obj.insurance.push({...this.insurance_column});
      this.oParam.forEach(param => {
        const param_key = param + '_column'
        if (this.application_obj[param] === false) {
          this.application_obj[param] = []
        }
        if (
          typeof this.application_obj[param] !== 'object' ||
          (typeof this.application_obj[param] === 'object' &&
            this.application_obj[param].length <= 0)
        ) {
          this.application_obj[param].push({ ...this[param_key] })
        }
      })
    }
    this.alertMessage = this.btnLabel + 'できます'

    this.$forceUpdate()
  },
  mounted() {
    // モーダルの初期化を修正
    const modalEl = this.$refs.rejectModal
    if (modalEl) {
      this.rejectModal = new bootstrap.Modal(modalEl)
    }
  },
  props: {}
}
</script>
